// Copyright (c) 2018 Comsearch, Inc., All rights reserved

// bulkEdit defines its own sorting for its paths
// this takes 'paths' which is a filtered List of the visible paths
// this then sorts the subset based on the sorting
// defined in bulkEdit redux state.

const sortPaths = paths => (dispatch, getState) => {
  const { bulkEdit } = getState()
  const asc = bulkEdit.get('sortAsc')
  const col = bulkEdit.get('sortCol')

  return paths.sort((a, b) => {
    const av = a.get(col)
    const bv = b.get(col)

    if (asc) {
      return (av >= bv) ? 1 : -1
    } else {
      return (av <= bv) ? 1 : -1
    }
  })
}

export default sortPaths
